import Navbar from '@/components/feature/Navbar';
import Hero from './components/Hero';
import ProblemSection from './components/ProblemSection';
import SolutionSection from './components/SolutionSection';
import MarketplaceCategories from './components/MarketplaceCategories';
import HowItWorks from './components/HowItWorks';
import ForHomes from './components/ForHomes';
import ForBusinesses from './components/ForBusinesses';
import ForPartners from './components/ForPartners';
import PlatformFeatures from './components/PlatformFeatures';
import TrustSection from './components/TrustSection';
import SolarCalculator from './components/SolarCalculator';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <main className="relative bg-background-50">
      <Navbar />
      <Hero />
      <ProblemSection />
      <SolutionSection />
      <MarketplaceCategories />
      <HowItWorks />
      <ForHomes />
      <ForBusinesses />
      <ForPartners />
      <PlatformFeatures />
      <TrustSection />
      <SolarCalculator />
      <FAQSection />
      <CTASection />
      <Footer />

      {/* Organization Schema.org structured data */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'Organization',
            name: 'AK Energy Australia',
            url: 'https://akenergy.com.au',
            logo: 'https://static.readdy.ai/image/ff63a95a3d068db59710e28833339873/473109dd943942010dc73e384d113dfa.png',
            description: 'Australia\'s trusted renewable energy marketplace connecting customers, businesses and renewable energy providers to accelerate the transition towards cleaner energy solutions.',
            email: 'akenergyau@gmail.com',
            telephone: '1800 253 637',
            address: {
              '@type': 'PostalAddress',
              addressCountry: 'AU',
              addressLocality: 'Sydney',
              addressRegion: 'NSW',
              postalCode: '2001',
              streetAddress: 'GPO Box 1234',
            },
            sameAs: [
              'https://www.linkedin.com/company/ak-energy',
              'https://twitter.com/akenergyau',
              'https://www.facebook.com/akenergyau',
              'https://www.instagram.com/akenergyau',
            ],
          }),
        }}
      />
    </main>
  );
}